import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { StateCreator } from 'zustand';

type MegaMenuState = {
  activeCategory: string;
  isOpen: boolean;
};

type MegaMenuActions = {
  setActiveCategory: (val: string) => void;
  setIsOpen: (val: boolean) => void;
};

type MegaMenuStore = MegaMenuState & MegaMenuActions;

export const ALL_CATEGORY = 'All';

const STORE_NAME = 'MEGA_MENU';
const KEYS = {
  SET_IS_OPEN: `${STORE_NAME}/setIsOpen`,
  SET_ACTIVE_CATEGORY: `${STORE_NAME}/setActiveCategory`,
};

const initialState: MegaMenuState = {
  isOpen: false,
  activeCategory: ALL_CATEGORY,
};

const createMegaMenuSlice: StateCreator<
  MegaMenuStore,
  [['zustand/devtools', never]],
  [],
  MegaMenuStore
> = set => ({
  ...initialState,
  setIsOpen: val => set(state => ({ ...state, isOpen: val }), undefined, KEYS.SET_IS_OPEN),
  setActiveCategory: val =>
    set(state => ({ ...state, activeCategory: val }), undefined, KEYS.SET_ACTIVE_CATEGORY),
});

export const useMegaMenuStore = create<MegaMenuStore>()(
  devtools((...args) => ({
    ...createMegaMenuSlice(...args),
  })),
);
